<div class="label_properties">
  <small class="debug">{{me}}</small>
  @if (isNestedScene) {
    <div>
      <span style="position: relative; top: -8px; left: 5px">
        <button color="warn" mat-flat-button (click)="linkToNestedScene()">
          <mat-icon>link</mat-icon>
          {{'general.jumpToScene' | transloco}}
        </button>
        <!--            <button mat-raised-button (click)="linkToNestedScene()">-->
        <!--                <mat-icon>link</mat-icon>-->
        <!--                {{'general.jumpToScene' | transloco}}-->
      <!--            </button>-->
    </span>
    <br/>
    <br/>
    <span>
      name: {{nestedSceneLabel}}
    </span>
    <br/>
  </div>
}

@if (mimeType && experienceLevel > experienceLevelType.BEGINNER) {
    @if (!isSceneTopPropsMode) {
        <br/>
        <div>
            <mat-label class="sceneTypeLabel">{{'general.sceneType' | transloco}}: {{mimeType}}</mat-label>
            <br/>
            <br/>
        </div>
    }
}
@if (!isNestedScene) {
  <div>
    @if (dynamicsInitialized) {
      <div>
        <dynamic-form [fields]="uiConfigInit" (submit)="submit($event)">
        </dynamic-form>
      </div>
    }
  </div>
}
@if (isMimeMainPlayer && !isSceneTopPropsMode && !isNestedScene && experienceLevel > experienceLevelType.BEGINNER) {
  <div>
    <fa-icon size="lg" [icon]="faPlugCircleCheck"></fa-icon>
    <mat-checkbox (change)="togglePlayerAssignable($event)" [checked]="isPlayerAssignable">{{'general.playerAssignable' | transloco}}</mat-checkbox>
  </div>
}
<br/>
@if (mimeType && !isMimeMainPlayer) {
  <div>
    <button mat-raised-button (click)="convertAssignable()">
      <fa-icon size="sm" class="status-icon assignedIcons" [icon]="faPlugCircleCheck"></fa-icon>
      {{'general.convertAssignable' | transloco}}
    </button>
  </div>
}
<br/>
<br/>
<br/>
<br/>
<br/>
<br/>
<br/>
</div>


      <!--    <div *ngIf="isPlayerAssignable && isSceneTopPropsMode">-->
      <!--        <app-scenes-scheduler [setSceneSelectionModel]="selectionModel"></app-scenes-scheduler>-->
    <!--    </div>-->

    <!--        <div *ngIf="isSceneTopPropsMode" class="select-playlist">-->
    <!--            <mat-form-field>-->
    <!--                <mat-label>{{'general.enableScheduler' | transloco}}</mat-label>-->
    <!--                <mat-select [(value)]="selectedSchedule" (selectionChange)="dropdownSchedulerChanged($event)">-->
    <!--                    <mat-option [value]="nonSelectedSchedule.schedule_id">{{nonSelectedSchedule.schedule_name}}</mat-option>-->
    <!--                    <mat-option *ngFor="let item of schedules" [value]="item.schedule_id">{{item.schedule_name}}</mat-option>-->
  <!--                </mat-select>-->
<!--            </mat-form-field>-->
<!--        </div>-->
<!--    </div>-->
<!--    <mat-form-field>-->
<!--        <mat-label>{{'general.accessKey' | transloco}}</mat-label>-->
<!--        <mat-select (selectionChange)="changeAccessMask($event.value)" [value]="accessSceneKey">-->
<!--            <mat-option *ngFor="let item of accessMask" [value]="item">{{item}}</mat-option>-->
<!--        </mat-select>-->
<!--    </mat-form-field>-->
